import React from 'react';

import { flagStyles } from '../settings';

const SvgMG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3360px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMG;
